import StatementScaleInput from 'views/components/taskGroups/tasks/template42/StatementScaleInput.svelte'
import Template42Svelte from './Template42.svelte'

export default class Template42 extends BaseView {

    initialize({
        taskView,
    }) {
        // To use the newer Svelte technology, create a proxy backbone view.
        // which has all the methods of a backbone view, but proxies the most
        // important methods to the svelte view.
        const svelteView = this.addSvelteChildView(
            this.$el,
            Template42Svelte,
            {
                model: this.model,
                response: taskView.response,
                syncResponse: taskView.saveResponse.bind(taskView),
            }
        );

        const methodsToProxy = [
            'showAnswer', 'showAuthorAnswer', 'hideAnswer', 'lockAnswer', 'unlockAnswer',
        ]

        for (const method of methodsToProxy) {
            this[method] = svelteView[method].bind(svelteView);
        }
    }

    getCorrectAnswer() {}

    getStudentAnswer(response) {
        if (
            response.has('json_answer') &&
            this.model.get('task_info_json').scale.some(({key}) => key === response.get('json_answer')[0])
        ) {
            const container = new BaseView()
            this.addSvelteChildView(
                container.el,
                StatementScaleInput,
                {
                    scale: this.model.get('task_info_json').scale,
                    value: response.get('json_answer')[0],
                    readonly: true,
                }
            )
            return container
        }
    }
}
